module.exports = __webpack_public_path__ + "images/178_2048.jpg";